import React from 'react';
import ScheduleCalendar from '../components/ScheduleCalendar';

const Scheduling: React.FC = () => {
  return (
    <div className="w-full max-w-[95%] mx-auto p-6 py-8 h-full flex flex-col min-h-0">
      <ScheduleCalendar />
    </div>
  );
};

export default Scheduling;

